// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__5noCN","icon":"style_icon__Xq_0u"};